export default __webpack_public_path__ + "ec5acbc5346964ddcb27277dbec7ae26.svg";